import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { VendorService } from 'src/app/services/core/services/vendors/vendor.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';
import { debounceTime, filter, Subject } from 'rxjs';
@UntilDestroy()

@Component({
  selector: 'app-vendors-list',
  templateUrl: './vendors-list.component.html',
  styleUrls: ['./vendors-list.component.css']
})
export class VendorsListComponent implements OnInit {
  currentPage: number = 1;
  totalPages = 0;
  filteredVendors: any;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  search: any = '';
  private searchSubject = new Subject<string>();
  vendorDetail: any;
  loadingId = null;
  syncType = null;
  selectedDropdownId: any;
  toggleActionButtons = false;
  companies: any;
  selectedCompanyId = null;
  vendors: any;

  constructor(
    private companyService: CompanyService,
    private vendorService: VendorService,
  ) { }

  ngOnInit(): void {
    this.getCompanies();
    this.initializeSearch();
    this.getAllVendors(this.currentPage);
  }

  getAllVendors(page: any) {
    let queryParams: any = {
      limit: this.numberOfRecords,
      page,
    }
    if (this.search) {
      queryParams.search = this.search.trim();
    }
    if (this.selectedCompanyId) {
      queryParams.company = this.selectedCompanyId;
    }
    this.vendorService.getVendors(queryParams)
      .pipe(untilDestroyed(this)).subscribe({
        next: (data: any) => {
          if (data) {
            this.vendors = data.results
            this.filteredVendors = this.vendors;
            this.totalPages = data.totalPages;
            this.totalResults = data.totalResults;
          }
        },
        error: (err) => {
          sweetAlert('Error', err, 'error', 'Ok');
        }
      })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllVendors(page);
  }

  openDetailModal(vendor: any) {
    this.vendorDetail = vendor;
  }

  async onSyncVendor(vendor: any, type: any) {
    const pull = 'Are you sure you want to overwrite vendor data with QuickBooks data?';
    const push = 'Are you sure you want to overwrite the QuickBooks data with vendor data';
    const result = await sweetAlert('Alert', type === 'pull' ? pull : push, 'warning', 'Yes', 'No');

    if (result.value) {
      this.loadingId = vendor.id;
      this.syncType = type;
      if (type === 'pull') vendor.pulling = true; else vendor.pushing = true;
      this.closeActionMenu();
      const companyId = vendor.company?.id || vendor.company?._id || vendor.company;
      this.vendorService.syncVendor(companyId, vendor.id, { isSyncFrom: type === 'pull' }).subscribe(
        {
          next: (data: any) => {
            this.getAllVendors(this.currentPage);
            sweetAlert('Success', data?.message || 'Synced successfully', 'success', 'Ok');
          },
          error: (err) => {
            sweetAlert('Error', err, 'error', 'Ok');
            vendor.pulling = false;
            vendor.pushing = false;
          },
          complete: () => {
            this.loadingId = null;
            this.syncType = null;
            vendor.pulling = false;
            vendor.pushing = false;
          }
        }
      )
    }
  }

  showActionButtons(id: any) {
    this.selectedDropdownId = id;
    this.toggleActionButtons = true;
  }

  closeActionMenu(_event?: any) {
    this.selectedDropdownId = null;
    this.toggleActionButtons = false;
  }

  getCompanies() {
    this.companyService.getCompanies().subscribe((data: any) => {
      if (data) {
        this.companies = data.results
      }
    })
  }

  filterVendors() {
    this.currentPage = 1;
    this.getAllVendors(this.currentPage);
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3),
        untilDestroyed(this)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getAllVendors(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }
}
